import React from 'react';

import { UnileverLogo } from '@assets/icons';
import { Modal } from '@components/index';

interface UnileverTermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UnileverTermsModal: React.FC<UnileverTermsModalProps> = ({
  isOpen,
  onClose,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    classOverride="w-[850px] p-8 flex flex-col gap-6"
  >
    <UnileverLogo />
    <div className="text-2xl font-bold text-blue-5">Terms of Service</div>
    <div className="text-sm font-medium">Last Updated: June 5, 2025</div>
    <div className="text-sm space-y-3 max-h-[60vh] overflow-y-auto pr-2">
      <p>
        Please read these terms and conditions before using the application,
        uploading, downloading or importing Assets. By using this Application
        you hereby agree to fully adhere to the following terms and conditions.
      </p>
      <ol className="list-decimal pl-7 space-y-4">
        <li>
          You hereby represent that you have the right to upload the asset for
          the purposes envisaged by the Application and that the Asset does not
          infringe any third-party intellectual property rights or other rights
          anywhere in the world. If your Asset is subject to any Usage
          Restrictions then you hereby agree to display such Usage Restrictions
          prominently with on the Application, by selecting either "None" or
          "Royalty Free" or "Rights Managed" and including all information
          requested;
        </li>
        <li>
          You will ensure that if you have selected "Rights Managed" for Usage
          Restrictions, that you accurately enter the full usage restrictions
          data for the asset being imported, as requested by the Application;
        </li>
        <li>
          You will ensure that any asset you're uploading, it is not marked as
          'Restricted' or 'Confidential' or 'Internal Unilever use only';
        </li>
        <li>
          You will ensure that your Asset is not threatening, defamatory,
          obscene, indecent, offensive, pornographic, abusive, liable to incite
          racial hatred, discriminatory, menacing, scandalous, inflammatory,
          blasphemous, or in breach of confidence;
        </li>
        <li>
          You will ensure that your Asset has all necessary authority, licences,
          permissions and/or approvals in order for you to import such Asset to
          the Application;
        </li>
        <li>
          Your Asset shall comply with all applicable laws, regulation and
          industry codes of practice (including but not limited to those
          relating to advertising, marketing, sales promotion and film
          certification);
        </li>
        <li>
          Your Asset must not be technically harmful and not include without
          limitation, any computer viruses, logic bombs, trojan horses, worms,
          harmful components, corrupted data or other malicious software or
          harmful data;
        </li>
        <li>
          When downloading any asset you will adhere to the asset usage rights;
        </li>
        <li>
          If an asset has been created for a specific brand within the Unilever
          portfolio, it should only be re-used for that brand unless written
          permission is obtained from the brand team originating the asset;
        </li>
        <li>
          Assets downloaded from the Application are for Unilever business
          purposes only. You therefore undertake not to disclose any Asset to a
          third party without prior written consent from Unilever or to use the
          Asset for any other purposes unless approved in writing by a Unilever
          authorized executive; and
        </li>
        <li>
          You must load assets using TAB technical file specifications and asset
          type classifications. Assets with incorrect specifications or
          classifications may be deleted without warning and your access may be
          revoked.
        </li>
      </ol>
    </div>
  </Modal>
);

export default UnileverTermsModal;
